module.exports = __webpack_public_path__ + "static/media/img_admission_01.02d1fb3a.png";